/** *
 * Filter out notEmpty results
 */
export const notEmpty = <TValue>(
    value: TValue | Error | null | undefined,
): value is TValue => {
    return value !== null && value !== undefined
}
